var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComingUpMegaphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_358_1",
    "data-name": "Component 358 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 223 151.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #a29bfe;\n        stroke-width: 4px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10 {\n        isolation: isolate;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-6, .cls-7, .cls-8, .cls-9 {\n        opacity: .4;\n      }\n\n      .cls-1, .cls-2, .cls-4, .cls-8, .cls-9 {\n        fill: none;\n        stroke-linecap: round;\n      }\n\n      .cls-11 {\n        fill: #2f2f7b;\n      }\n\n      .cls-2 {\n        stroke: #fdcb6e;\n        stroke-width: 5px;\n      }\n\n      .cls-12, .cls-10 {\n        fill: #c4dcff;\n      }\n\n      .cls-13 {\n        fill: #15156b;\n      }\n\n      .cls-3 {\n        fill: #00d08f;\n      }\n\n      .cls-4 {\n        stroke: #fb639e;\n        stroke-miterlimit: 4;\n        stroke-width: 5px;\n      }\n\n      .cls-14 {\n        fill: #79ead1;\n      }\n\n      .cls-5 {\n        opacity: .09;\n      }\n\n      .cls-6 {\n        fill: #fdcb6e;\n      }\n\n      .cls-7 {\n        fill: #a29bfe;\n      }\n\n      .cls-8 {\n        stroke: #00cec9;\n      }\n\n      .cls-8, .cls-9 {\n        stroke-width: 5px;\n      }\n\n      .cls-15 {\n        fill: #1e8469;\n      }\n\n      .cls-9 {\n        stroke: #00d08f;\n      }\n\n      .cls-10 {\n        opacity: .5;\n      }\n\n      .cls-16 {\n        fill: #20c5a0;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Megaphone"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_127",
    "data-name": "Ellipse 127",
    className: "cls-5",
    cx: 166.4,
    cy: 131,
    rx: 51,
    ry: 9
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_691",
    "data-name": "Group 691"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Confetti"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Megaphone-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    className: "cls-11",
    d: "m190.08,107.25c-3.8,4.38-16.99,18.75-19.17,21.26-1.83,2.11-7.67,2.97-8.89,1.35l-.23-.67c0-.21.03-.42.1-.61,1.67-4.72,5.22-4.41,6.59-6.25.58-.78,0-2.88.82-4.13l.35-.38c1.14-.91,3.72-1.01,5-2.72,1.1-1.46.85-2.92,1.8-4.78.33-.64.74-1.23,1.21-1.77l4.09-4.7.43.18,7.92,3.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    className: "cls-13",
    d: "m161.89,128.59c-.07.2-.11.4-.1.61l-2.73-7.92-.3-.9c0-.16.03-.33.09-.48,1.66-4.71,5.22-4.41,6.6-6.24.58-.8-.03-2.93.81-4.17s3.9-1.15,5.33-3.06.62-3.78,3.03-6.56l4.09-4.71,8.32,3.4c-1.05,1.21-2.82,3.18-4.86,5.47l-.43-.18-4.09,4.71c-.47.54-.88,1.13-1.21,1.77-.95,1.87-.7,3.32-1.8,4.78-1.28,1.71-3.86,1.81-5,2.72-.13.09-.24.2-.33.33l-.02.04c-.82,1.24-.24,3.35-.82,4.13-1.37,1.83-4.93,1.52-6.59,6.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    className: "cls-13",
    d: "m189.71,101.24c-3.46,3.94-7.48,5.74-11.18,5.2-1.85-.28-3.58-1.09-4.97-2.34-2.04-1.89-3.55-4.29-4.37-6.95-3.45-9.96-.61-24.5,6.29-32.4,3.36-3.85,7.27-5.66,10.88-5.24,1.95.23,3.79,1.06,5.25,2.37,2.05,1.89,3.56,4.3,4.38,6.96.69,2.06,1.13,4.2,1.31,6.36.57,7.06-.79,14.14-3.93,20.48-.99,1.99-2.22,3.86-3.66,5.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    className: "cls-12",
    d: "m188.51,100.19c-3.11,3.55-6.51,5.07-9.6,4.7-8.84-.96-59.72,11.51-72.65,10.9,5.79.22,12.05-2.67,17.84-8.86.35-.36.67-.73,1.01-1.11,4.33-5.13,7.76-10.95,10.14-17.23,3.54-9.13,5.37-18.84,5.38-28.64.07-6.44-.92-12.85-2.92-18.97-2.51-7.25-6.31-12.31-10.81-15.06,12.82,6.2,38.36,23.42,52.39,31.44l.71.4c2.22,1.32,4.54,2.47,6.93,3.45,3.18.68,5.95,3.44,7.57,8.15,2.68,7.74,1.39,18.33-2.73,26.05-.89,1.72-1.98,3.33-3.25,4.78h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    className: "cls-10",
    d: "m188.51,100.2c-3.11,3.55-6.51,5.07-9.6,4.7-8.83-.97-59.72,11.51-72.65,10.89,5.79.22,12.05-2.67,17.84-8.86,19.81-2.76,54.19-12.61,61.35-11.83,2.09.29,4.21.39,6.32.3-.89,1.72-1.98,3.33-3.26,4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    className: "cls-14",
    d: "m215.24,106.15c-3.34,3.83-7.22,5.62-10.83,5.25l-.02-.02-1.47-.27h-.03s-24.36-4.68-24.36-4.68c3.7.55,7.73-1.26,11.18-5.2,1.44-1.68,2.67-3.54,3.67-5.52v-.03c3.15-6.34,4.51-13.42,3.94-20.48-.18-2.17-.63-4.3-1.31-6.36-.82-2.67-2.33-5.07-4.38-6.96-1.46-1.31-3.3-2.14-5.25-2.37l.03-.05,25.77,5.01.86.17h.05c1.51.4,2.9,1.15,4.07,2.19,2.04,1.89,3.55,4.28,4.38,6.94,2.75,7.97,1.5,18.85-2.64,26.93-1,1.96-2.22,3.79-3.65,5.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    className: "cls-15",
    d: "m215.24,106.15c-3.34,3.83-7.22,5.62-10.83,5.25l-.02-.02-1.47-.27h-.03s-24.36-4.68-24.36-4.68c3.7.55,7.73-1.26,11.18-5.2,1.44-1.68,2.67-3.54,3.67-5.52l25.5,4.97c-.99,1.96-2.21,3.8-3.64,5.47h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    className: "cls-13",
    d: "m199.88,97.91l10.74,2.09.73-.84-10.74-2.09-.73.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    className: "cls-13",
    d: "m197.72,100.4l10.74,2.09.73-.84-10.74-2.09-.73.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    className: "cls-11",
    d: "m94.45,113.09c-4.13-3.84-7.18-8.7-8.85-14.09-7.1-20.58-1.28-50.59,12.98-66.91,7.2-8.22,15.47-11.9,23.3-10.36,2.17.43,4.24,1.24,6.12,2.4,1,.62,1.94,1.31,2.82,2.09,4.14,3.83,7.19,8.69,8.86,14.08,7.1,20.58,1.26,50.6-12.99,66.92-6.25,7.15-13.54,10.95-20.51,10.69l-.53-.04h-.13c-4.11-.36-7.99-2.04-11.07-4.78h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    className: "cls-12",
    d: "m125.11,105.82c-2,2.34-4.29,4.4-6.81,6.15-3.5,2.52-7.71,3.86-12.03,3.83l-.61-.03c-7.57-.58-14.29-6.53-18.06-17.44-6.89-19.98-1.24-49,12.59-64.83,6.9-7.9,14.52-11.02,21.31-9.69,1.92.37,3.75,1.09,5.41,2.13,2.46,1.55,4.58,3.57,6.23,5.96,1.96,2.8,3.5,5.86,4.57,9.1,6.89,19.98,1.25,49-12.59,64.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    className: "cls-10",
    d: "m125.11,105.81c-2,2.34-4.29,4.4-6.81,6.15-5-1.92-9.27-6.79-11.9-14.42-6.04-17.54-1.1-43.01,11.04-56.9,5.05-5.79,10.55-8.65,15.7-8.76,1.96,2.8,3.5,5.86,4.57,9.1,6.89,19.98,1.25,49.01-12.59,64.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    className: "cls-16",
    d: "m135.24,88.58l-8.94-4.09-10.94-5.02c1.63.17,3.23-.56,4.18-1.9,2.82-3.62,3.74-8.38,2.47-12.79-.38-1.62-1.6-2.91-3.2-3.38l11.92-.8,9.88-.66c-.01,9.8-1.83,19.51-5.37,28.64h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    className: "cls-15",
    d: "m126.3,84.49c5.83-4.71,9.35-19.42,4.44-23.88l9.88-.66c-.02,9.8-1.84,19.5-5.38,28.64l-8.94-4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    className: "cls-11",
    d: "m122.01,64.8c1.27,4.41.35,9.15-2.47,12.77-2.72,3.11-6.03,2.44-7.39-1.49-1.25-4.41-.33-9.15,2.48-12.76,2.73-3.12,6.04-2.45,7.38,1.48Z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_4851",
    "data-name": "Path 4851",
    className: "cls-2",
    d: "m52.64,60.52l-9.67-19-15.71,8.13-6.81-19.36L2.5,38.99"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_130",
    "data-name": "Ellipse 130",
    className: "cls-7",
    cx: 88.4,
    cy: 7,
    r: 7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_183",
    "data-name": "Line 183",
    className: "cls-8",
    x1: 68.64,
    y1: 81.55,
    x2: 35.64,
    y2: 84.55
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_131",
    "data-name": "Ellipse 131",
    className: "cls-3",
    cx: 12.66,
    cy: 49.79,
    r: 5.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_184",
    "data-name": "Line 184",
    className: "cls-9",
    x1: 63.14,
    y1: 31.48,
    x2: 81.54,
    y2: 43.32
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_132",
    "data-name": "Ellipse 132",
    className: "cls-6",
    cx: 56.64,
    cy: 121.26,
    r: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4852",
    "data-name": "Path 4852",
    className: "cls-4",
    d: "m47.95,121.81s1.05,10.5,9.79,8.22,6.73-10.98,6.73-10.98c0,0-2.44-9.38,4.36-11.86s11.53,6.51,11.53,6.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4853",
    "data-name": "Path 4853",
    className: "cls-1",
    d: "m68.64,149.57l10.2-1.25-1.09-8.45,9.89.11-.98-9.55"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingUpMegaphone);
export default __webpack_public_path__ + "static/media/ComingUpMegaphone.69bafab16b585aba30d99aa8543c7cde.svg";
export { ForwardRef as ReactComponent };